import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ConfigService {

  public language: string = "en";
  constructor() { }

  public TimeOut: number = 2000000;
  public BlinkIDAndroid: string = "";
  public BlinkIDIOS: string = "";
  public OtpResendTime: string = "";
  public captchaEndpoint: string = "";
  public server: string = undefined;
  public VidyoHost: string = ''
  public BlinkTimeOut;
  public SMSAnnuallyLink;
  public SMSMonthlyLink;
  public StatementDeclaration:string="I/We do hereby authorize the Bank to send Bank statement of all my accounts of my/our account with Faysal Bank through email (E-SOA) instead of paper statement. I understand that paper statement will be discontinued, once I sign up for e-statements.     Further I/We hereby undertake that it would be my/our sole responsibility to keep the mentioned email address active, valid and protected in all respects.";
  public StatementUnderTaking:string="I undertake and agree to receive e-statements and agree to {termscondition}.";







  public backbuttonStateName: string = ""
  public ServerVersion: string = "";
  public dateFormat: string = "DD MMMM YYYY"
  public Morning: string = "";
  public Afternoon: string = "";
  public Evening: string = "";
  public vidoeKey: string = "";
  public videoSecret: string = "";
  public AllowedTypeArray: string = "";
  public oecdsite: string = "";
  public ReferralCode: string = "";
  public RefCodeExpiry: string = "";
  public BlinkIDWeb: string = "";
  public Deploytest: string = "";
  public videotimeout: number = 60;
  public Switchrecaptcha: string = ""




  GetGreeting() {

    let dt = new Date();
    let currentHour: string = dt.getHours().toString();
    currentHour = ("0" + currentHour).slice(-2);
    let currentMinutes: string = dt.getMinutes().toString();
    currentMinutes = ("0" + currentMinutes).slice(-2);

    if (currentHour + ":" + currentMinutes <= this.Morning) {
      return "Good Morning";
    }
    else if (currentHour + ":" + currentMinutes <= this.Afternoon) {
      return "Good Afternoon";
    }
    else if (currentHour + ":" + currentMinutes <= this.Evening) {
      return "Good Evening";
    }
    else {
      return "Good Night";
    }
  }
}
